var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3037 17.2218C8.67408 17.2218 8.33398 17.5417 8.33398 19.0737V21.8515C8.33398 23.3837 8.67408 23.7033 10.3037 23.7033H14.2431V34.8145C14.2431 36.3465 14.5832 36.6663 16.2128 36.6663H20.1522C21.7818 36.6663 22.1218 36.3465 22.1218 34.8145V23.7033H26.5452C27.7812 23.7033 28.0997 23.4775 28.4392 22.3603L29.2833 19.5825C29.8648 17.6687 29.5065 17.2218 27.3893 17.2218H22.1218V12.5923C22.1218 11.5695 23.0037 10.7404 24.0915 10.7404H29.6977C31.3272 10.7404 31.6673 10.4207 31.6673 8.88856V5.18486C31.6673 3.65276 31.3272 3.33301 29.6977 3.33301H24.0915C18.6523 3.33301 14.2431 7.47852 14.2431 12.5923V17.2218H10.3037Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.52ead51459378b7fd82e07674c030455.svg";
export { ForwardRef as ReactComponent };